export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de la recolección"])},
          "items": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ítems"])}
        }
      }
    }
  })
}